export const AC_ONE_COLUMN_SECTION = 'ac-alpha-section';
export const AC_TWO_COLUMN_SECTION = 'ac-alpha-two-section';
export const AC_THREE_COLUMN_SECTION = 'ac-alpha-three-column';

//LABELS
export const AC_ONE_COLUMN_SECTION_LABEL = '1 Column';
export const AC_TWO_COLUMN_SECTION_LABEL = '2 Column';
export const AC_THREE_COLUMN_SECTION_LABEL = '3 Column';

//SELECTORS
export const AC_TWO_COLUMN_SECTION_SELECTOR = 'ac-alpha-two-section-1.0.0';
export const AC_THREE_COLUMN_SECTION_SELECTOR = 'ac-alpha-three-column-1.0.0';
export const AC_ONE_COLUMN_SECTION_SELECTOR = 'ac-alpha-section-1.0.0';

//NUMBER OF COLUMNS
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
